import { GlobalErrorPayload, GlobalErrorState } from "@/store/modules/globalError/state";

const mutations = {
  setGlobalError(state: GlobalErrorState, payload: GlobalErrorPayload) {
    state.currentGlobalError = payload;
  },
};

export default mutations;
